export const state = () => ({
  selectedCurrency: { id: 1, name: 'en-Us', currency: 'USD', path: 'flags/usd', display: '' },
  currencies: [
    { id: 1, name: 'en-Us', currency: 'USD', path: 'flags/usd', display: '' },
    { id: 2, name: 'en-GB', currency: 'GBP', path: 'flags/gbp', display: '' },
    { id: 3, name: 'eu', currency: 'EUR', path: 'flags/eur', display: '' },
    { id: 4, name: 'en-AU', currency: 'AUD', path: 'flags/aud', display: 'AU' },
    { id: 5, name: 'en-CA', currency: 'CAD', path: 'flags/cad', display: 'C' },
    { id: 6, name: 'ja-JP', currency: 'JPY', path: 'flags/jpy', display: '' },
    { id: 7, name: 'zh-hk', currency: 'HKD', path: 'flags/hkd', display: '' },
  ],
})

export const mutations = {
  // setCurrencies(state, payload) {
  //     state.currencies = payload
  // },
  setSelectedCurrency(state, payload) {
    state.selectedCurrency = payload
  },
}

export const actions = {
  // async getCards({ commit }) {
  //     try {
  //         const response = await client.getEntries({
  //             content_type: 'currencies'
  //         });
  //         if (response.items.length > 0) {
  //             commit('setCurrencies', response.items.map(el => el.fields));
  //         }
  //     } catch (error) {
  //         // you could redirect to custom error page for instance
  //         console.error(error);
  //     }
  // },
}
